var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8332 0C6.08633 0 6.2956 0.188007 6.32873 0.432053L6.33333 0.4999L6.33413 5.33333H11.1695C11.4457 5.33333 11.6695 5.5572 11.6695 5.83333C11.6695 6.08647 11.4814 6.29567 11.2374 6.3288L11.1695 6.33333H6.33413L6.33546 11.1661C6.33553 11.4422 6.11173 11.6662 5.8356 11.6662C5.58246 11.6662 5.3732 11.4782 5.34006 11.2341L5.33546 11.1663L5.33413 6.33333H0.501465C0.225318 6.33333 0.00146484 6.10947 0.00146484 5.83333C0.00146484 5.5802 0.189565 5.371 0.433618 5.33787L0.501465 5.33333H5.33413L5.33333 0.5001C5.33326 0.22396 5.55706 0 5.8332 0Z",
    fill: "#212121"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.24205d0c3cf291c05f485059542184d0.svg";
export { ForwardRef as ReactComponent };